import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function Hero() {
  const { elementRef: headlineRef } = useScrollAnimation();
  const { elementRef: descRef } = useScrollAnimation({ delay: 100 });
  const { elementRef: ctaRef } = useScrollAnimation({ delay: 200 });
  const { elementRef: socialRef } = useScrollAnimation({ delay: 300 });

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/82c9a80e060e89ad0328ac0531169e9b.jpg"
          alt="Diverse fitness training"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center py-20">
        
        {/* Headline */}
        <div ref={headlineRef} className="animate-fade-up mb-6">
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black leading-tight mb-4 text-white">
            Transform Your Life.<br />Build Your Legacy.
          </h1>
        </div>

        {/* Description */}
        <div ref={descRef} className="animate-fade-up mb-10">
          <p className="text-base sm:text-lg md:text-xl max-w-3xl mx-auto leading-relaxed" style={{ color: '#f0f0f0' }}>
            Elite online coaching for busy professionals who refuse to settle. Get the body, energy, and confidence you deserve — without sacrificing your career or family.
          </p>
        </div>

        {/* CTA Buttons */}
        <div ref={ctaRef} className="animate-fade-up flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
          <a
            href="#booking"
            className="w-full sm:w-auto flex items-center justify-center gap-3 px-8 py-4 rounded-xl font-bold text-base transition-all duration-300 cursor-pointer whitespace-nowrap hover:opacity-90 hover:-translate-y-0.5"
            style={{
              background: 'linear-gradient(90deg, #B8860B, #F5D76E)',
              color: '#000000',
              boxShadow: '0 8px 24px rgba(184,134,11,0.35)',
            }}
          >
            <i className="ri-rocket-line text-xl"></i>
            Start Your Transformation
          </a>
          <a
            href="#services"
            className="w-full sm:w-auto flex items-center justify-center gap-3 px-8 py-4 rounded-xl font-bold text-base transition-all duration-300 cursor-pointer whitespace-nowrap hover:bg-white/20"
            style={{
              background: 'rgba(255,255,255,0.1)',
              color: '#ffffff',
              border: '2px solid rgba(255,255,255,0.3)',
              backdropFilter: 'blur(10px)',
            }}
          >
            <i className="ri-arrow-down-line text-xl"></i>
            See How It Works
          </a>
        </div>

        {/* Social Proof */}
        <div ref={socialRef} className="animate-fade-up">
          <div className="inline-flex flex-col sm:flex-row items-center gap-4 sm:gap-6 px-6 py-4 rounded-2xl" style={{ background: 'rgba(0,0,0,0.4)', backdropFilter: 'blur(20px)', border: '1px solid rgba(255,255,255,0.1)' }}>
            {/* Avatars */}
            <div className="flex -space-x-3">
              {[1, 2, 3, 4, 5].map((i) => (
                <div
                  key={i}
                  className="w-10 h-10 rounded-full flex items-center justify-center"
                  style={{ background: 'linear-gradient(135deg, #B8860B, #F5D76E)', border: '2px solid rgba(0,0,0,0.4)' }}
                >
                  <i className="ri-user-fill text-sm" style={{ color: '#000000' }}></i>
                </div>
              ))}
            </div>
            {/* Text */}
            <div className="text-center sm:text-left">
              <p className="text-sm font-bold text-white mb-0.5">500+ Lives Transformed</p>
              <div className="flex items-center justify-center sm:justify-start gap-1">
                {[1, 2, 3, 4, 5].map((i) => (
                  <i key={i} className="ri-star-fill text-xs" style={{ color: '#F5D76E' }}></i>
                ))}
                <span className="text-xs ml-1" style={{ color: '#cccccc' }}>4.9/5 Average Rating</span>
              </div>
            </div>
          </div>
        </div>

      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-2xl text-white opacity-60"></i>
      </div>
    </section>
  );
}